module.exports = __webpack_public_path__ + "static/media/serviceQualityNew.2c3708ed.svg";